import { type ClassValue, clsx } from "clsx";
import { parse, setHours, setMinutes, startOfDay } from "date-fns";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function base64PDFToBlobUrl(mimeType: string, base64: string) {
  const binStr = atob(base64);
  const len = binStr.length;
  const arr = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    arr[i] = binStr.charCodeAt(i);
  }
  const blob = new Blob([arr], { type: mimeType });
  const url = URL.createObjectURL(blob);
  return url;
}

export function getBase64FromFile(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
}

export function getDateFromSlotTime(
  date: Date | undefined,
  slotTime: string | undefined,
) {
  if (!date || !slotTime) return new Date();

  const parsedTime = parse(slotTime, "hh:mm aa", new Date());

  const hours = parsedTime.getHours();
  const minutes = parsedTime.getMinutes();

  return setMinutes(setHours(startOfDay(date), hours), minutes);
}

export function calculateBMI(height: number, weight: number): string {
  if (!height || !weight) return "";
  const heightInMeters = height / 100; // Convert cm to meters
  const bmi = weight / (heightInMeters * heightInMeters);
  return bmi.toFixed(1); // Return BMI rounded to 1 decimal place
}